import React from "react";

// Placeholder shown while the lazy TipTap item chunk loads. The geometry mirrors
// NewsDrawerItem (.news-drawer-item / .news-card-meta / .news-card-image) so the
// real content swaps in without shifting the layout.
const SkeletonItem = () => (
  <div className="news-skeleton-item">
    <div className="news-card-meta">
      <span className="news-skeleton-bone news-skeleton-title" />
      <span className="news-skeleton-bone news-skeleton-date" />
    </div>

    <span className="news-skeleton-bone news-skeleton-image" />

    <div className="news-skeleton-body">
      <span className="news-skeleton-bone news-skeleton-line" />
      <span className="news-skeleton-bone news-skeleton-line" />
      <span className="news-skeleton-bone news-skeleton-line" />
    </div>
  </div>
);

const NewsDrawerSkeleton = ({ count = 3 }) => {
  const rows = Array.from(
    { length: count },
    (_, i) => `news-skeleton-row-${i}`
  );

  return (
    // Purely decorative placeholder — hidden from assistive tech so it isn't
    // announced in place of the real announcements a moment later.
    <div className="news-skeleton" aria-hidden="true">
      {rows.map((row, i) => (
        <React.Fragment key={row}>
          {i > 0 && <hr className="news-drawer-divider" />}
          <SkeletonItem />
        </React.Fragment>
      ))}
    </div>
  );
};

export default NewsDrawerSkeleton;
